import { render, staticRenderFns } from "./StatementDialog.vue?vue&type=template&id=3260cbbc&scoped=true&"
import script from "./StatementDialog.vue?vue&type=script&lang=js&"
export * from "./StatementDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3260cbbc",
  null
  
)

export default component.exports